import { Component, OnInit } from '@angular/core';
import { LiftDetail } from '../../models/lift-detail.model';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { LiftRideCriteria } from '../../models/lift-ride.criteria';
import { LiftRideService } from '../../services/lift-ride.service';


import { L10n, setCulture, loadCldr } from '@syncfusion/ej2-base';
import { LoginService } from '../../../user/services/login.service';
declare var require: any;

loadCldr(
  require("cldr-data/main/cs/numbers.json"),
  require("cldr-data/main/cs/ca-gregorian.json"),
  require("cldr-data/supplemental/numberingSystems.json"),
  require("cldr-data/main/cs/timeZoneNames.json"),
  //require('cldr-data/supplemental/weekdata.json') // To load the culture based first day of week
);


L10n.load({
  'cs': {
    datepicker: {
      placeholder: "Vyberte datum",
      today: "Dnes"
    }
  }
});

setCulture('cs');

@Component({
  selector: 'app-lift-ride',
  templateUrl: './lift-ride.component.html',
  styleUrls: ['./lift-ride.component.css']
})
export class LiftRideComponent implements OnInit {
  menu = 'ride';
  lift: LiftDetail;
  liftId: number;
  floors: number[] = [];
  primaryXAxis: Object;
  chartData: Object[];
  rawData: Object[];
  rideCriteria: LiftRideCriteria;
  legendSettings: Object;
  marker: Object;

  countAll = 0;
  avarageDayRides = 0;

  showLoader = false;

  //Permissions
  canViewErrors: boolean = false;
  canView: boolean = false;
  canControl: boolean = false;
  canViewParameter: boolean = false;

  constructor(
    private route: ActivatedRoute,
    public translateService: TranslateService,
    private liftRideService: LiftRideService,
    private loginService: LoginService
  ) { }

  ngOnInit() {
    this.liftId = +this.route.snapshot.paramMap.get('id');
    this.lift = this.route.snapshot.data.lift;
    let data = this.route.snapshot.data.rides;

    let liftPermission = this.route.snapshot.data.liftPermission;
    if (!liftPermission) {
      liftPermission = [];
    }

    this.canViewErrors = liftPermission.indexOf('2') > -1 || this.loginService.isSuperadmin();
    this.canView = liftPermission.indexOf('0') > -1 || this.loginService.isSuperadmin();
    this.canControl = liftPermission.indexOf('3') > -1 || this.loginService.isSuperadmin();
    this.canViewParameter = liftPermission.indexOf('4') > -1 || this.loginService.isSuperadmin();

    this.rideCriteria = new LiftRideCriteria();
    this.rideCriteria.liftId = this.liftId;

    for (var i = 0; i < this.lift.floorCount; i++) {
      this.floors.push(i);
    }

    this.showLoader = true;
    this.rawData = data;
    let templateData = this.createDayGraphTemplate();
    let preparedData = this.handleData(templateData, data);
    this.chartData = preparedData;
    this.showLoader = false;

    this.primaryXAxis = {
      valueType: 'Category'
    };

    this.legendSettings = {
      visible: true
    };

    this.marker = {
      dataLabel: {
        visible: true
      }
    };

    this.showLoader = false;
  }

  dateFromChanged() {
    this.dataChange();
  }

  dateToChanged() {
    this.dataChange();
  }

  floorChanged() {
    console.log(this.rideCriteria.floor);
    this.showLoader = true;
    let templateData = this.createDayGraphTemplate();
    let preparedData = this.handleData(templateData, this.rawData);
    this.chartData = preparedData;
    this.showLoader = false;
  }

  dataChange() {
    this.showLoader = true;
    this.liftRideService
      .getRides(this.rideCriteria.paramsExport()).subscribe((data) => {
        this.rawData = data;
        let templateData = this.createDayGraphTemplate();
        let preparedData = this.handleData(templateData, data);
        this.chartData = preparedData;
        this.showLoader = false;
      });
  }

  /*
  Create initial data state for graph. Graph is merged with real data in the next step. 
  */
  createDayGraphTemplate() {
    let dateArray = [];
    let currentDate = moment(this.rideCriteria.dateFrom);
    let stopDate = moment(this.rideCriteria.dateTo);

    while (currentDate <= stopDate) {
      let day = {
        date: moment(currentDate).format('YYYY-MM-DD'),
        labelDate: moment(currentDate).format('DD.MM.YYYY'),
        value:0 // Math.floor(Math.random() * 100)
      }
      dateArray.push(day);
      currentDate = moment(currentDate).add(1, 'days');
    }

    return dateArray;
  }

  handleData(dataTemplate, serverData) {
    let countAll = 0;

    
    serverData.forEach(item => {
      if (this.rideCriteria.floor != null && item.floor != this.rideCriteria.floor) {
        return;
      }

      let dateToken = item.date.substring(0, 10);
      dataTemplate[dataTemplate.findIndex(el => el.date === dateToken)] = {
        date: dataTemplate[dataTemplate.findIndex(el => el.date === dateToken)].date,
        labelDate: dataTemplate[dataTemplate.findIndex(el => el.date === dateToken)].labelDate,
        value: dataTemplate[dataTemplate.findIndex(el => el.date === dateToken)].value + item.recordCount
      };
      countAll += item.recordCount;
    });
    

    const filteredArray = dataTemplate.filter(item => item.value > 0);
    if (filteredArray.length > 0) {
      this.avarageDayRides = Math.floor(countAll / filteredArray.length);
    } else {
      this.avarageDayRides = 0;
    }    
    this.countAll = countAll;
    return dataTemplate;
  }
}
